module.exports = __webpack_public_path__ + "static/media/mail.0846b6f9.svg";